<template>
  <div class="search">
    <div class="filter">
      <datetime type="date"
        v-model="startDate"
        input-id="datetime_start"
        input-class="input inlineInput">
      </datetime>
      <datetime type="date"
        v-model="endDate"
        input-id="datetime_end"
        input-class="input inlineInput">
      </datetime>
      <button type="button" class="btn btnPrimary"
        @click="onClickSearch">{{locale.search}}</button>
    </div>
    <div class="datePreset mt15">
      <button type="button" class="btn btnWhite sizeXs" @click="setSearchDate('lastWeek')">{{locale.lastweek}}</button>
      <button type="button" class="btn btnWhite sizeXs" @click="setSearchDate('thisWeek')">{{locale.thisweek}}</button>
      <!-- <button type="button" class="btn btnWhite sizeXs" @click="setSearchDate('lastMonth')">{{locale.lastmonth}}</button> -->
      <button type="button" class="btn btnWhite sizeXs" @click="setSearchDate('thisMonth')">{{locale.thismonth}}</button>
      <!-- <button type="button" class="btn btnWhite sizeXs" @click="setSearchDate('3monthAgo')">{{locale.monthago_3}}</button>
      <button type="button" class="btn btnWhite sizeXs" @click="setSearchDate('2monthAgo')">{{locale.monthago_2}}</button> -->
      <button type="button" class="btn btnWhite sizeXs" @click="setSearchDate('1monthAgo')">{{locale.monthago_1}}</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'
import Datetime from 'vue-datetime/src/Datetime.vue'

export default {
  name: 'Search',
  props: [
    'locale',
    'filter'
  ],
  components: {
    datetime: Datetime
  },
  computed: {
    startDate: {
      get () {
        return this.filter.startDate
      },
      set (date) {
        this.$emit('updateStartDate', date)
      }
    },
    endDate: {
      get () {
        return this.filter.endDate
      },
      set (date) {
        this.$emit('updateEndDate', date)
      }
    },
    barChartType () {
      return this.chartType === 'bar_h' ? 'horizontal' : ''
    }
  },
  methods: {
    setSearchDate (date) {
      let startDate
      let endDate
      switch (date) {
        case 'lastWeek':
          startDate = moment().startOf('week').add(-1, 'weeks').add(1, 'days')
          endDate = moment().startOf('week')
          break
        case 'thisWeek':
          startDate = moment().isoWeekday(1).startOf('isoweek')
          endDate = moment()
          break
        case '1monthAgo':
          startDate = moment().add(-1, 'months')
          endDate = moment()
          break
        case '2monthAgo':
          startDate = moment().add(-2, 'months')
          endDate = moment()
          break
        case '3monthAgo':
          startDate = moment().add(-3, 'months')
          endDate = moment()
          break
        case 'lastMonth':
          startDate = moment().startOf('months').add(-1, 'months')
          endDate = moment().startOf('months').add(-1, 'days')
          break
        case 'thisMonth':
          startDate = moment().startOf('months')
          endDate = moment()
          break
        default:
          startDate = moment().add(-7, 'days')
          endDate = moment()
      }
      this.$emit('updateStartDate', startDate.toISOString())
      this.$emit('updateEndDate', endDate.toISOString())
    },
    onClickSearch () {
      const filterDate = this.filter
      this.$emit('search', {
        dateFrom: filterDate.startDate,
        dateTo: filterDate.endDate
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  margin-bottom: 60px;
  text-align: center;
}
.filter {
  display: flex;
  align-items: center;
  justify-content: center;
  .vdatetime + .vdatetime:before {
    content: "-";
    margin: 0 0.3em;
  }
  .btn {
    margin-left: 1em;
  }
}
.tableSearch {
  margin-bottom: 30px;
  padding: 30px 0;
  text-align: center;
  border-bottom: 1px solid $color-lgrey2;
  background-color: $bg-default;
}
.datePreset {
  .btn + .btn {
    margin-left: 0.3em;
  }
}
</style>
